// extracted by mini-css-extract-plugin
export var organized = "style-module--organized--1b0db";
export var organized__blockItem = "style-module--organized__block-item--ab167";
export var organized__title = "style-module--organized__title--30828";
export var whom = "style-module--whom--f72d5";
export var whom__block = "style-module--whom__block--b9bb8";
export var whom__img = "style-module--whom__img--46efe";
export var whom__imgVideo = "style-module--whom__img-video--8eefb";
export var whom__point = "style-module--whom__point--d554b";
export var whom__points = "style-module--whom__points--c5240";